import { render, staticRenderFns } from "./AnalyticsSavings.vue?vue&type=template&id=e05e3bac&"
import script from "./AnalyticsSavings.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsSavings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports